import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const QUOTES = [
  {
    text: "Testei por meses até ficar impossível de diferenciar de um brownie tradicional. A diferença é que esse não me sabota.",
    author: "Da autora · The Quick Brownie",
  },
  {
    text: "Em casa, 5 brownies saem por menos da metade do preço de uma gastronomia fit — e saem exatamente do jeito que a gente gosta.",
    author: "Economia por kit",
  },
  {
    text: "Sem açúcar, sem glúten, sem lactose, com colágeno hidrolisado. Doçura real pra quem não abre mão.",
    author: "Promessa da edição",
  },
];

export default function RecipeTestimonials() {
  return (
    <section data-testid="recipe-testimonials" className="bg-white">
      <div className="mx-auto max-w-[1500px] px-6 md:px-10 py-24 md:py-32">
        <motion.div
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }} transition={{ duration: 0.8 }}
          className="flex items-end justify-between flex-wrap gap-6"
        >
          <div>
            <div className="flex items-center gap-3 text-xs uppercase tracking-[0.3em]">
              <span className="inline-block w-10 h-px bg-black" />
              <span>Promessa</span>
            </div>
            <h2 className="font-display mt-6 text-4xl sm:text-6xl md:text-7xl leading-[0.95] tracking-[-0.025em]">
              O que a edição<br />entrega.
            </h2>
          </div>
        </motion.div>

        <ul className="mt-14 md:mt-20 grid md:grid-cols-3 gap-0 border-t border-l border-black">
          {QUOTES.map((q, i) => (
            <motion.li
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className="border-r border-b border-black p-6 md:p-10 min-h-[260px] flex flex-col justify-between"
            >
              <Quote size={28} strokeWidth={1.5} />
              <div>
                <p className="font-display text-xl md:text-2xl leading-tight tracking-[-0.01em]">
                  “{q.text}”
                </p>
                <p className="mt-5 text-[11px] uppercase tracking-[0.22em]">— {q.author}</p>
              </div>
            </motion.li>
          ))}
        </ul>
      </div>
    </section>
  );
}
